module.exports = __webpack_public_path__ + "img/sieckFinesseSetup9.37728944.png";